import React from 'react';
import Box from '@mui/material/Box';
import MainLogoWhite from '@components/layout/Header/MainLogoWhite';
import MenuCloseIcon from '@components/layout/Header/MenuCloseIcon';

interface ModalHeaderProps {
  handleClose: () => void;
}

export default function ModalHeader({ handleClose }: ModalHeaderProps): React.JSX.Element {
  return (
    <Box className="flex justify-between items-center m-5 mt-[21px]">
      <MainLogoWhite />
      <Box className="flex items-center">
        <MenuCloseIcon onClick={handleClose} />
      </Box>
    </Box>
  );
}
